<div class="overLayDiv active"></div>

<div id="rightSideBar">
  <div class="rightSidePanel active">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
        <h2 *ngIf="!showCardExpiryNotification">
          {{ "payment_failed" | translate }}
        </h2>
        <h2 *ngIf="showCardExpiryNotification && cardExpiryDays > 0">
          {{ "reminder_credit_card_abount_to_expire" | translate }}
        </h2>
        <h2 *ngIf="showCardExpiryNotification && cardExpiryDays <= 0">
          {{ "reminder_credit_card_expired" | translate }}
        </h2>
      </div>
    </header>
    <div class="block mt-2" *ngIf="orgGoogleInvoiceFailedRecord">
      <div class="row">
        <div class="col-md-12 px-0 border-bottom pb-3">
          <ul class="">
            <li class="">
              <p class="text-charcoal-black lH-28">
                <span
                  ><i
                    class="fas f-16 fa-exclamation-circle color-red align-middle"
                    aria-hidden="true"></i
                ></span>
                <strong
                  ><span class="padding-left-5 f-16 font-weight-bold">{{
                    "payment_failed_google_mapping_service" | translate
                  }}</span></strong
                >

                <br />
                <span class="padding-left-20">{{
                  "please_click_on_payment_button"
                    | translate
                }}</span>
              </p>
            </li>
          </ul>
        </div>
        <div class="col-md-12 pt-3 justify-content-center d-flex">
          <button
            class="btn eod-btn-primary"
            [class.disabled]="submitted"
            (click)="fnPayGooglePackage()">
            {{ "label_pay_now" | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="block mt-2" *ngIf="orgTransactionDownloadInvoiceFailedRecord">
      <div class="row">
        <div class="col-md-12 px-0 border-bottom pb-3">
          <ul class="">
            <li class="">
              <p class="text-charcoal-black lH-28">
                <span
                  ><i
                    class="fas f-16 fa-exclamation-circle color-red align-middle"
                    aria-hidden="true"></i
                ></span>
                <strong
                  ><span class="padding-left-5 f-16 font-weight-bold">{{
                    "Automatic Transaction download has failed" | translate
                  }}</span></strong
                >

                <br />
                <span class="padding-left-20">{{
                  "please_click_on_payment_button"
                    | translate
                }}</span>
              </p>
            </li>
          </ul>
        </div>
        <div class="col-md-12 pt-3 justify-content-center d-flex">
          <button
            class="btn eod-btn-primary"
            [class.disabled]="submitted"
            (click)="fnPayAutomaticTransactionDownload()">
            {{ "label_pay_now" | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="block mt-2" *ngIf="orgSubscriptionInvoiceFailedRecord">
      <div class="row">
        <div class="col-md-12 px-0 border-bottom pb-3">
          <ul class="">
            <li class="">
              <p class="text-charcoal-black lH-28">
                <span
                  ><i
                    class="fas f-16 fa-exclamation-circle color-red align-middle"
                    aria-hidden="true"></i
                ></span>
                <strong
                  ><span class="padding-left-5 f-16 font-weight-bold">{{
                    "payment_failed_for_subscription" | translate
                  }}</span></strong
                >

                <br />
                <span class="padding-left-20">{{
                  "please_click_on_payment_button"
                    | translate
                }}</span>
              </p>
            </li>
          </ul>
        </div>
        <div class="col-md-12 pt-3 justify-content-center d-flex">
          <button
            class="btn eod-btn-primary"
            [class.disabled]="submitted"
            (click)="fnPaySubscription()">
            {{ "label_pay_now" | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="block mt-2" *ngIf="showCardExpiryNotification">
      <div class="row">
        <div class="col-md-12 px-0 border-bottom pb-3">
          <ul class="">
            <li class="">
              <p class="text-charcoal-black lH-28">
                <span
                  ><i
                    class="fas f-16 fa-exclamation-circle color-red align-middle"
                    aria-hidden="true"></i
                ></span>
                <strong
                  ><span *ngIf="cardExpiryDays <= 0" class="padding-left-5 f-16 font-weight-bold"
                    >{{"cc_expired_note" |translate}}</span
                  ><span *ngIf="cardExpiryDays > 0" class="padding-left-5 f-16 font-weight-bold"
                    >{{"cc_expire_note_1" |translate}}
                    <span class="color-red f-16 font-weight-bold"
                      >{{"cc_expire_note_2" |translate}} {{ cardExpiryDays }} {{"cc_expire_note_3" |translate}}</span
                    ></span
                  ></strong
                >

                <br />
                <span class="padding-left-20">{{
                  "please_click_on_update_card"
                    | translate
                }}</span>
              </p>
            </li>
          </ul>
        </div>
        <div class="col-md-12 pt-3 justify-content-center d-flex">
          <button
            class="btn eod-btn-primary"
            [class.disabled]="submitted"
            (click)="goToCardUpdate()">
            {{ "update_card" | translate }}
          </button>

          <button *ngIf="cardExpiryDays>0"
          class="btn eod-btn-warning ml-2"
          [class.disabled]="submitted"
          (click)="onUpdateLater()">
          {{ "update_later" | translate }}
        </button>
        </div>
      </div>
    </div>
  </div>
</div>
